<mat-card class="invoice-container mat-elevation-z8">
  <div class="invoice-header">
    <div class="info-wrap">
      <figure class="logo">
        <img src="{{ sellerProfile?.company_logo }}" />
      </figure>
      <div class="divider"></div>
    </div>
    <div class="title">
      <h2>{{ sellerProfile.company }}</h2>
      <div class="heading-data">
        <div class="date">
          <div>
            <span>DATE:</span>
            <span>DUE DATE:</span>
            <span>TERMS:</span>
          </div>
          <div>
            <span>{{ printFilters.start_date | date : "MM/dd/yyyy" }}</span>
            <span>{{ printFilters.end_date | date : "MM/dd/yyyy" }}</span>
            <span> Due on receipt</span>
          </div>
        </div>

        <div>
          <span><b>FROM:</b></span>
          <span>{{ sellerProfile.company }}</span>
          <span>{{ sellerProfile.address }}</span>
          <span>{{ sellerProfile.phone }}</span>
          <span>{{ sellerProfile.email }}</span>
        </div>
        <div *ngIf="buyerProfile">
          <span><b>TO:</b></span>
          <span> {{ buyerProfile?.name }} </span>
          <span> {{ buyerProfile?.company }} </span>
          <span> {{ buyerProfile?.address }} </span>
          <span>{{ buyerProfile?.phone }}</span>
          <span>{{ buyerProfile?.email }}</span>
          <span> {{ buyerProfile?.city }} {{ buyerProfile?.state.name }} </span>
          <span> {{ buyerProfile?.state?.country?.name }} </span>
        </div>
      </div>
    </div>
  </div>

  <table class="simple invoice-table">
    <thead>
      <tr>
        <th *ngFor="let title of titles">{{ title }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of itemList; let i = index">
        <td>{{ i + 1 }}</td>
        <td>Sales</td>
        <td>
          {{ item.product.title }} {{ item.product.currency_data.symbol
          }}{{ item.original_price | number }}
        </td>
        <td>
          {{ item.count | number }}
        </td>
        <td>
          {{ item?.product.currency_data.symbol }}{{ item.unit_price | number }}
        </td>
        <td>
          {{ item.product.currency_data.symbol
          }}{{ item.count * item.unit_price | number }}
        </td>
      </tr>
    </tbody>
  </table>

  <table class="simple invoice-table-footer">
    <tbody *ngIf="itemList?.length">
      <tr class="subtotal">
        <td>SUBTOTAL</td>
        <td>
          {{ itemList[0]?.product.currency_data.symbol
          }}{{ calcTotal() | number }}
        </td>
      </tr>
      <tr class="total">
        <td>TOTAL</td>
        <td>
          {{ itemList[0]?.product.currency_data.symbol
          }}{{ calcTotal() | number }}
        </td>
      </tr>
    </tbody>
  </table>

  <div class="footer">
    <!-- <div class="note">Please pay within 15 days. Thank you for your business.</div> -->
    <div class="footer-wrap">
      <div class="logo">
        <img [src]="environmentConfig.logoSrc" />
      </div>
      <div class="small-note">
        EZ Pin solutions provide the tools and resources you need to launch and
        manage your digital gift card programs successfully and securely. Our
        solutions enable your business to implement effective strategies to
        reach and acquire new customers while providing your customers with more
        choices and opportunities for redemption.
      </div>
    </div>
  </div>
</mat-card>
